import React from 'react';
import { EMPTY } from 'rxjs';
import { defineMessages, FormattedMessage } from 'react-intl';

import { DocumentType } from '../../../enums/document-type';

const messages = defineMessages({
  printingOtherFormsSuccessTitle: {
    description: 'printEpics.printingOtherFormsSuccessTitle',
    defaultMessage: 'Printing {docCount, plural,=0 {Form} one {Form} other {Forms}}...',
    id: 'bwQ20i',
  },
  printingOtherFormsSuccessContent: {
    description: 'printEpics.printingOtherFormsSuccessContent',
    defaultMessage: '{docCount, plural,=0 {Form} one {Form} other {Forms}} sent to {printerName}.',
    id: '7YbIZm',
  },
  downloadOtherFormssStartedTitle: {
    description: 'printEpics.downloadOtherFormsStartedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Form} one {Form} other {Forms}}...',
    id: 'pTihmx',
  },
  downloadOtherFormssStartedContent: {
    description: 'printEpics.downloadOtherFormsStartedContent',
    defaultMessage: '{docCount, plural,=0 {Form} one {Form} other {Forms}} Download Started.',
    id: 'fCA4Gy',
  },
  downloadOtherFormssCompletedTitle: {
    description: 'printEpics.downloadOtherFormsCompletedTitle',
    defaultMessage: 'Downloading {docCount, plural,=0 {Other Form} one {Other Form} other {Other Forms}}...',
    id: 'TbGz0E',
  },
  downloadOtherFormssCompletedContent: {
    description: 'printEpics.downloadOtherFormsCompletedContent',
    defaultMessage: '{docCount, plural,=0 {Other Form} one {Other Form} other {Other Forms}} Download Completed.',
    id: 'nOWq/W',
  },
});

export const otherForms = {
  id: DocumentType.OtherForms.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadOtherFormssStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadOtherFormssStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadOtherFormssCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadOtherFormssCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingOtherFormsSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingOtherFormsSuccessContent} values={{ docCount, printerName }} />,
  }),

  getPrintedSuccessObservable: () => {
    return EMPTY;
  },
};
